// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { WebsiteInitializationSettings } from "@lib/api/website/WebsiteInitializationSettings";

export interface IBootstrapWebsiteApi
{
  initialize(settings: WebsiteInitializationSettings): void;
};